export const GET_ALLOYDIAMETERS_STATED = 'GET_ALLOYDIAMETERS_STATED';
export const GET_ALLOYDIAMETERS = 'GET_ALLOYDIAMETERS';
export const GET_ALLOYDIAMETERS_ENDED = 'GET_ALLOYDIAMETERS_ENDED';

export const ADD_ALLOYDIAMETER_STATED = 'ADD_ALLOYDIAMETER_STATED';
export const ADD_ALLOYDIAMETER = 'ADD_ALLOYDIAMETER';
export const ADD_ALLOYDIAMETER_ENDED = 'ADD_ALLOYDIAMETER_ENDED';

export const EDIT_ALLOYDIAMETER_STATED = 'EDIT_ALLOYDIAMETER_STATED';
export const EDIT_ALLOYDIAMETER = 'EDIT_ALLOYDIAMETER';
export const EDIT_ALLOYDIAMETER_ENDED = 'EDIT_ALLOYDIAMETER_ENDED';

export const GET_ALLOYDIAMETER_STATED = 'GET_ALLOYDIAMETER_STATED';
export const GET_ALLOYDIAMETER = 'GET_ALLOYDIAMETER';
export const GET_ALLOYDIAMETER_ENDED = 'GET_ALLOYDIAMETER_ENDED';

export const GET_ALL_ALLOYDIAMETERS_STATED = 'GET_ALL_ALLOYDIAMETERS_STATED';
export const GET_ALL_ALLOYDIAMETERS = 'GET_ALL_ALLOYDIAMETERS';
export const GET_ALL_ALLOYDIAMETERS_ENDED = 'GET_ALL_ALLOYDIAMETERS_ENDED';
